// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1123":"39dbc49c","1635":"eff19d28","3385":"c5f6682c"}[chunkId] + ".chunk.css";
};